import styled from 'styled-components';


export const MainStyle = styled.div`
    display:flex;
    .None{
        flex-basis:10%;
    }
    margin-bottom: 100px;
`;
